import { createContext, useState, useContext } from "react";
import { SettingContextI } from "../types";

export const SettingContext = createContext<any>({
  modalContent: "",
  setModalContent: "",
  showModal: "",
  setShowModal: "",
  setShowCancel: "",
  showCancel: true,
});

export const GeneralContext = createContext<any>({
  modalContent: "",
  setModalContent: "",
  showModal: "",
  setShowModal: "",
  setShowCancel: "",
  showCancel: true,
});

interface routeProps {
  name: string;
  val: string;
}

export const SettingModal = (props: any) => {
  const [modalContent, setModalContent] = useState<any>("");
  const [showModal, setShowModal] = useState<any>(false);
  const [showCancel, setShowCancel] = useState<any>(true);
  const [route, setRoute] = useState<routeProps>();

  const value: SettingContextI = {
    modalContent,
    setModalContent,
    showModal,
    setShowModal,
    showCancel,
    setShowCancel,
    route,
    setRoute,
  };

  const children = props.children;

  return (
    <SettingContext.Provider value={value}>{children}</SettingContext.Provider>
  );
};

export const GeneralModal = (props: any) => {
  const [modalContent, setModalContent] = useState<any>("");
  const [showModal, setShowModal] = useState<any>(false);
  const [showCancel, setShowCancel] = useState<any>(true);
  const value2 = {
    modalContent,
    setModalContent,
    showModal,
    setShowModal,
    showCancel,
    setShowCancel,
  };
  const children = props.children;

  return (
    <GeneralContext.Provider value={value2}>{children}</GeneralContext.Provider>
  );
};

export const useSettingModal = () => {
  return useContext(SettingContext);
};

export const useModal = () => {
  return useContext(GeneralContext);
};
